import { createSelector } from '@ngrx/store';
import { chain, memoize } from 'lodash';
import { selectState } from './conversation.selectors';
import { conversationToastMessageAdapter } from '../adapters';

const { selectAll } = conversationToastMessageAdapter.getSelectors();
const selectToastMessagesSubState = createSelector(selectState, state => state.toastMessages);

const selectToastMessagesByConversationId = memoize((conversationId: string) => createSelector(
  selectToastMessagesSubState,
  state => state[conversationId] ? selectAll(state[conversationId]) : []
));

export const selectLatestThreeToastMessagesByConversationId = memoize((conversationId: string) => createSelector(
  selectToastMessagesByConversationId(conversationId),
  toastMessages => chain(toastMessages).take(3)
    .reverse()
    .value()
));
